import Vue from "vue";
import PouchDB from "pouchdb";
import App from "@/App.vue";
import router from "@/router";
import { SessionPlugin } from "./session.js";
import reactiveCache from "./reactive-cache.js";

Vue.config.productionTip = false;

function mainAppCallback() {
  App.router = router;
  window.main = new Vue(App).$mount("#app");
  // Note:
  //     const app = new Vue({
  //       router,
  //       render: (h) => h(App),
  //     }).$mount("#app");
  // (generated by create vue) doesn't work properly with root component data.
}

if (process.env.NODE_ENV === "development") {
  const localDB = new PouchDB("localDB");
  window.pouch = localDB;
  reactiveCache.init(localDB, [localDB]).then(mainAppCallback);
} else {
  Vue.use(SessionPlugin);
  Vue.initSession().then(mainAppCallback);
}

// import * as OfflinePluginRuntime from 'offline-plugin/runtime';

// // I pack this boolean in to an extra object, so that Vue has something it can
// // watch. RootComponent will take this object and put it into its data.
// window.swInfo = {
//   updateReady: false,
// };

// // Offline plugin (ServicWorker)
// window.swUpdate = false;
// if (__OFFLINE_PLUGIN_ENABLED__) {
//   OfflinePluginRuntime.install({
//     onUpdateReady() {
//       console.log('Apply update');
//       OfflinePluginRuntime.applyUpdate();
//     },
//     onUpdated() {
//       console.log('Updated');
//       window.swInfo.updateReady = true;
//     },
//   });
// }
